import { createActionCreator } from 'deox';
import { BrandRtps, FetchRtpsMockOptions, VirtualLookupMockOptions } from '../models/rtps.model';
import { Prescreen, VirtualLookup } from 'fmc-sdk';

export const brandSubmitRTPS = createActionCreator(
  'RTPS:BRAND_SUBMIT_RTPS', resolve =>
    (customerInfo: BrandRtps, mockResponse?: FetchRtpsMockOptions | VirtualLookupMockOptions) => resolve({
      customerInfo,
      mockResponse
    })
);

// fetchVirtualLookup
export const fetchPrescreen = createActionCreator(
  'RTPS:FETCH_PRESCREEN', resolve =>
    (customerInfo: BrandRtps, mockResponse?: FetchRtpsMockOptions) => resolve({
      customerInfo,
      mockResponse
    })
);

export const virtualLookupReq = createActionCreator(
  'RTPS:VIRTUAL_LOOKUP', resolve =>
    (customerInfo: BrandRtps, mockResponse?: VirtualLookupMockOptions) => resolve({
      customerInfo,
      mockResponse
    })
);

export const submitRtpsSuccess = createActionCreator(
  'RTPS:SUBMIT_RTPS_SUCCESS', resolve =>
    (prescreen: Prescreen, customerInfo?: BrandRtps, mockResponse?: FetchRtpsMockOptions) => resolve({
      prescreen,
      customerInfo,
      mockResponse
    })
);

export const submitVirtualLookupSuccess = createActionCreator(
  'RTPS:SUBMIT_VIRTUAL_LOOKUP_SUCCESS', resolve =>
    (virtualLookup: VirtualLookup, customerInfo?: BrandRtps, mockResponse?: VirtualLookupMockOptions) => resolve({
      virtualLookup,
      customerInfo,
      mockResponse
    })
);

export const displayPrescreenApprovedOffer = createActionCreator(
  'RTPS:DISPLAY_PRESCREEN_APPROVED_OFFER', resolve =>
    (prescreen: Partial<Prescreen>, customerInfo?: BrandRtps, mockResponse?: FetchRtpsMockOptions) => resolve(
      {
        prescreen,
        customerInfo,
        mockResponse
      })
);

export const displayBpsApprovalOffer = createActionCreator(
  'RTPS:DISPLAY_BATCH_PRESCREEN_APPROVED_OFFER', resolve =>
    (virtualLookup: Partial<VirtualLookup>, customerInfo?: BrandRtps, mockResponse?: VirtualLookupMockOptions) => resolve({
      virtualLookup,
      customerInfo,
      mockResponse
    })
);

export const displayTenderRebuttal = createActionCreator(
  'RTPS:DISPLAY_TENDER_REBUTTAL', resolve =>
  (prescreen: Partial<Prescreen>) => resolve(prescreen)
);
